<template>
  <div class="ly-nest-table level-content" :class="`table-${currentKey}-${level}-content`" ref="lyNestTableRef">
    <qf-table :tableSkeletonRows="5" v-if="columns?.length" :columns="columns" :data="tableData" :pagination="tableData?.length ? pagination : false" :loading="loading" @paginationEvent="paginationEvent" activeRowType="single" expandType="single" row-key="id" :ref="(el) => (tableRef = el)" :expand-icon="hasNextLevel" :activeRowKeys="expandedRowKeys" :expandedRowKeys="expandedRowKeys" @expand-change="handleExpandChange">
      <!-- <template #empty>
        <jw-empty :img-src="noDataSvg" :description="'暂无数据'"></jw-empty>
      </template> -->

      <template #operations="{ row }">
        <div class="operation-button" v-if="isCanEdit && buttonShortcut?.length && row.LOGIC_ROLE_PERMISSION && row.LOGIC_ROLE_PERMISSION == 1" @click.stop="">
          <ly-list-shortcut-buttons :viewId="multiTable?.modules?.[0]?.parentId" :entityId="businessDataEntity" :fieldsListAll="buttonShortcut" :recordObj="row" @cb="getTableEntityData"></ly-list-shortcut-buttons>
        </div>
        <div v-else>-</div>
      </template>

      <!-- 自定义固定列 -->
      <template #customCheckbox="{ row, index }">
        <div class="index-container">
          <div class="index-num show-detail-icon">{{ index + 1 }}</div>
          <jw-tooltip content="查看详情">
            <div class="index-detail-icon" @click.stop="toDetails(row)">
              <qfei-icon-full-screen-outlined />
            </div>
          </jw-tooltip>
        </div>
      </template>

      <!-- 字段图标 -->
      <template #prefix="{ col }">
        <component :is="getFieldIcn(col)" />
        <!-- {{col}} -->
      </template>

      <!-- 展开收起 -->
      <template #expandIcon="{ rowKey }">
        <div class="fh-table-expand-icon">
          <qfei-icon-caret-right-outlined v-if="!expandedRowKeys.includes(rowKey)" style="font-size: 10px" />
          <qfei-icon-caret-down-outlined v-else style="font-size: 10px" />
        </div>
      </template>

      <!-- <template #empty>
        <ly-skeleton v-if="loading" fromType="table" :row="1" :tableColumns="columns"></ly-skeleton>
        <div class="fh-table-spin" v-else>
          <jw-empty>
            <template #image></template>
          </jw-empty>
        </div>
      </template> -->

      <!-- 递归加载多层级内容 -->
      <template #expandRow="{ row }">
        <!-- 只传递三个核心属性和两个内部属性 -->
        <fh-detail-nest-table v-if="hasNextLevel" :isCanEdit="isCanEdit" :currentKey="currentKey" :parentEntity="getCurrentLevelMultiTable()?.businessData" :multiTable="getNextLevelMultiTable()" :parentId="row?.id" :level="level + 1" />
      </template>
    </qf-table>
    <template v-else>
      <fh-list-skeleton :rows="5" :columns="5" />
    </template>
  </div>

  <ly-detail ref="detailRef" mask @cb="refreshList"></ly-detail>
</template>

<script setup>
import { publicService } from '@/api/';
import FhListSkeleton from '@/components/fh-list/fh-list-skeleton/fh-list-skeleton.vue';
import { ref, computed, onMounted, provide, nextTick } from 'vue';
import { QfeiIconCaretRightOutlined, QfeiIconCaretDownOutlined, QfeiIconFullScreenOutlined } from '@qfei-design/icons-vue';
// import LyTemplateSlot from '@/components/layout/ly-template-slot/ly-template-slot.vue'; //列表插槽组件

import { useLyTableConfig } from '@/hooks/ly-table-config';
import { objectRoleEnum } from '@/utils/const';
import useEventListener from '@/hooks/event-listener';
import useFields from '@/hooks/fields';
const { fieldIconMapping } = useFields(); // 获取字段图标

// import noDataSvg from '@/assets/images/no-data-150.svg';

const { eventListener } = useEventListener();

const getFieldIcn = (field) => {
  if (!field) return null;
  return fieldIconMapping.value[Number(field?.fieldType || 0)];
};

const specialProduct = [7, 9, 11, 14, 32]; //特殊产品对象
// const ready = ref(false);

// 定义props - 只保留三个核心参数和必要的内部参数
const props = defineProps({
  // 核心参数 - 外部传入
  parentEntity: { type: Number, default: 0 }, // 实体ID
  multiTable: { type: Object, default: () => ({}) }, // 当前层级配置信息
  parentId: { type: Number, default: 0 }, // 展开行的数据id
  level: { type: Number, default: 1 }, // 当前层级
  currentKey: { type: String },
  // 内部参数 - 递归调用时使用
  isCanEdit: {
    type: Boolean,
    default: true
  }
});

const lyNestTableRef = ref(null);
const entityRef = ref(props.parentEntity);
const tableRef = ref(null);
const loading = ref(false);
const parentId = ref(props.parentId);

const buttonShortcut = ref(
  props.multiTable?.modules
    ?.filter((v) => v.type == 40 && v?.value != (props.multiTable?.businessData < 200 ? objectRoleEnum[props.multiTable?.businessData] + ':add' : props.multiTable?.businessData + ':add'))
    .map((n) => {
      return n.value;
    })
);

const { getComputedErrorLog, assTableData, getTableLevelColumns } = useLyTableConfig(entityRef, props.level + 1);

//给多级表格加动态宽度
const setClientWidth = (curClassName, minus) => {
  nextTick(() => {
    // 最外层父级元素宽度
    const getTableLevel1Width = document.querySelector(`.table-${props.currentKey}-content`)?.offsetWidth;
    // 当前层级元素 取getClassName要取自己的上级的所以传参需要-1
    const tableLevel1Content = document.querySelector(curClassName);
    if (tableLevel1Content) {
      const expandedRowInner = tableLevel1Content.querySelector('.t-table__expanded-row-inner');
      if (expandedRowInner) {
        // 动态设置宽度
        expandedRowInner.style.width = getTableLevel1Width - minus + 'px'; // 你可以将 '890px' 替换为动态计算的值
      } else {
        console.log('未找到 .t-table__expanded-row-inner 元素');
      }
    } else {
      console.log('未找到 .table-level-1-content 元素');
    }
  });
};

// 分页配置 - 使用默认配置
const pagination = ref({
  current: 1,
  pageSize: 5,
  total: 0,
  foldedMaxPageBtn: 2,
  maxPageBtn: 4,
  showPageSize: true, // 是否显示数据条数选择器
  showJumper: true,
  size: 'small',
  pageSizeOptions: [5, 10],
  showTotal: true // 是否显示数据总数
});

// 展开行相关 - 内部管理展开状态
const expandedRowKeys = ref([]);

// 初始化为外部提供的列，如果没有提供则为空数组，在initCurrentLevelColumns中填充
const columns = ref([]);

// 定义内部状态变量
const tableData = ref([]);
const businessDataEntity = computed(() => props.multiTable?.businessData); // 当前entity

// 获取当前表格数据
const getTableEntityData = async (isLoading = true) => {
  // 始终使用当前层级的配置信息
  loading.value = isLoading;

  // 获取当前层级的multiTable配置
  const multiTableConfig = getCurrentLevelMultiTable();
  // 获取当前层级对象的entity

  // 使用props.entity作为关联对象entity
  const itselfTableEntity = entityRef.value;

  // 当前层级已经通过props.level标记

  let layoutId = null; // 布局id
  let layoutConfigId = null; // 布局的id
  let businessId = null; // 数据id

  layoutId = multiTableConfig?.layoutId;
  layoutConfigId = multiTableConfig?.id;
  businessId = parentId.value; // 数据id

  // 如果没有业务ID，则不进行请求
  if (!businessId) {
    console.warn('没有业务ID，无法获取数据');
    return;
  }

  const params = {
    itselfTableEntity: itselfTableEntity,
    tableEntity: businessDataEntity.value,
    layoutId: layoutId,
    layoutConfigId: layoutConfigId,
    businessId: businessId, // 数据id
    page: pagination.value.current,
    pageSize: pagination.value.pageSize,
    apiIndex: `${businessDataEntity.value}_${businessId}_${Math.random() * 100}`
  };

  try {
    const res = await publicService.getTableEntityData(params);
    if (!res.error) {
      const rt = res.result;
      const businessIdList = rt.records.map((rItem) => rItem.id);
      const computedInfo = await getComputedErrorLog(businessIdList, businessDataEntity.value);
      const processedData = assTableData(rt.records, computedInfo);
      // 始终更新当前层级数据，因为现在只关注当前层级
      // 无论是第几层，都应该更新自己的数据
      tableData.value = processedData;
      pagination.value = {
        ...pagination.value,
        current: rt.current,
        total: rt.total
      };
    }
    loading.value = false;
  } catch (e) {
    loading.value = false;
  }
};

// 分页相关
const paginationEvent = async (page, pageSize) => {
  pagination.value.current = page;
  pagination.value.pageSize = pageSize;
  await getTableEntityData(false);
};

// 行点击事件 - 在组件内部处理

const setEntity = ref();
const setId = ref();
const detailRef = ref(); //公共抽离组件
const hasNextLevel = ref(false);

// 展开行事件 - 简化逻辑
const handleExpandChange = ({ expandRowKeys }) => {
  expandedRowKeys.value = [];
  if (expandRowKeys && expandRowKeys?.length) {
    // 更新展开状态
    expandedRowKeys.value.push(expandRowKeys[expandRowKeys.length - 1]);
  }
};

// 获取当前层级的multiTable配置
const getCurrentLevelMultiTable = () => {
  // 如果是第一层，直接返回完整的multiTable
  return props.multiTable;
};

// 获取下一层级的multiTable配置
const getNextLevelMultiTable = () => {
  // 查找当前配置中的type=30模块，作为下一级的配置
  const nextLevelModule = props.multiTable?.modules?.find((fItem) => fItem.type == 31);
  return nextLevelModule || null;
};

// 从当前层级的multiTable中推导列配置
const initCurrentLevelColumns = () => {
  // 始终从 multiTable 推导列配置，不使用外部提供的 columns
  // 获取当前层级的multiTable配置
  const currentMultiTable = getCurrentLevelMultiTable();
  if (!currentMultiTable) return;
  columns.value = getTableLevelColumns(currentMultiTable?.modules, tableData, currentMultiTable?.businessData);
};

// 在组件初始化时获取数据
onMounted(async () => {
  // 初始化列配置
  initCurrentLevelColumns();
  // 检查是否有展开行数据
  if (props.parentId) {
    loading.value = true;
    await getTableEntityData(true);
  }

  setClientWidth(`.table-${props.currentKey}-${props.level - 1}-content`, props.level * 16);

  // 检查是否有下一层级
  const nextLevelConfig = getNextLevelMultiTable();
  hasNextLevel.value = !!nextLevelConfig;
});

const refreshList = async () => {
  //刷新2 3级表格数据 如果有展开数据的话
  await getTableEntityData(false);
};

// 跳转详情
const toDetails = (record) => {
  if (specialProduct.includes(Number(businessDataEntity.value))) {
    //特殊产品显示不能点击状态
    return false;
  }
  setId.value = record.id;
  setEntity.value = businessDataEntity.value;
  detailRef.value.openDialog();
};

//动态调整内容宽度
eventListener('resize', () => setClientWidth(`.table-${props.currentKey}-${props.level - 1}-content`, props.level * 16));

provide('globalParams', {
  id: computed(() => setId.value),
  entity: computed(() => setEntity.value),
  columns: computed(() => columns.value),
  viewId: -1
});
</script>
<style scoped lang="less">
@import './fh-detail-nest-table.less';
</style>
